/* eslint-disable default-case */
import React, { useEffect, useState, useReducer, useRef } from 'react';
import {
   Input, Table, Typography, Space, Tooltip, Button, List, Row, Col,
   Modal, Spin, Popconfirm, InputNumber, Tag, Tabs, Progress
} from 'antd';
import * as AntDIcons from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import SimpleBarReact from "simplebar-react";
import axios from 'axios';
import uuid from 'react-uuid';
import Utils from '../../../misc/Utils';
import Iframe from 'react-iframe';
import './Submissions.css'
import DocumentViewer from '../../../components/document-viewer/DocumentViewer';
// import RenderPDFViewer from '../../../components/iframe-viewer/pdfViewer';
// import { PDFReader } from 'reactjs-pdf-reader';
// import { RenderPDFReader } from '../../../components/pdfreader/RenderPDFReader';
// import Split from 'react-split';
// Import the styles
import { useDownloadExcel } from 'react-export-table-to-excel';

// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
// import "@cyntler/react-doc-viewer/dist/index.css";

const { Text } = Typography;
const { TextArea } = Input;
const { TabPane } = Tabs;
var pdfFile = '';

const plagiarismSupportedFileTypes = [
   "pdf", "doc", "docx", "odt", "rtf", "txt", "md", "html", "xml", "json", "csv"
];

export default function Submissions(props) {
   const workTypeLabel = props.type === 'project'
      ? 'Project'
      : props.type === 'microcredential'
         ? 'Microcredential'
         : 'Homework';
   const tableRef = useRef(null);

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [submissionList, setSubmissionList] = useState([]);
   const [submissionListLoading, setSubmissionListLoading] = useState(false);
   const [checkEvaluateModalVisible, setCheckEvaluateModalVisible] = useState(false);
   const [studentName, setStudentName] = useState("");
   const [submittedDocument, setSubmittedDocument] = useState(null);
   const [documentLink, setDocumentLink] = useState(null);
   const [uploadedDocs, setUploadedDocs] = useState(null);
   const [selectedDocumentIdx, setSelectedDocumentIdx] = useState(-1);
   const [maxScore, setMaxScore] = useState(null);
   const [submissionID, setSubmissionID] = useState(null);
   const [documentTab, setDocumentTab] = useState("preview");
   const [plagiarismCheckerStatus, setPlagiarismCheckerStatus] = useState({
      url: "",
      checking: false,
      checked: false,
      exists: false,
   });

   const [evaluationData, setEvaluationData] = useState({
      Id: "",
      Homework_submitted_id: "",
      Score: null,
      Remarks: ""
   })
   const [score, setScore] = useState(0);
   const [remarks, setRemarks] = useState("");
   const [evaluating, setEvaluating] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      pdfFile = '';

      getStudentSubmissions(props.homeworkID, props.levelID);
   }, [props.homeworkID, props.levelID]);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
               {/* <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button> */}
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const SubmissionListColumns = [
      {
         title: 'Student',
         key: 'student_name',
         dataIndex: 'student_name',
         sorter: (a, b) => { return (a.student_name === null ? '' : a.student_name).localeCompare(b.student_name === null ? '' : b.student_name) },
         ...getColumnSearchProps('student_name'),
         ellipsis: {
            showTitle: true,
         },
         render: student_name => (
            <Tooltip placement="right" title={student_name}>
               <span style={{ cursor: "default" }}>{student_name}</span>
            </Tooltip>
         ),
         width: '14%'
      },
      {
         title: 'Section',
         key: 'section_name',
         dataIndex: 'section_name',
         sorter: (a, b) => { return (a.section_name === null ? '' : a.section_name).localeCompare(b.section_name === null ? '' : b.section_name) },
         ...getColumnSearchProps('section_name'),
         ellipsis: {
            showTitle: true,
         },
         render: section_name => (
            <Tooltip placement="right" title={section_name}>
               <span style={{ cursor: "default" }}>{section_name}</span>
            </Tooltip>
         ),
         width: '12%'
      },
      {
         title: 'Student Message',
         key: 'message',
         dataIndex: 'message',
         // sorter: (a, b) => { return (a.message === null ? '' : a.message).localeCompare(b.message === null ? '' : b.message) },
         ellipsis: {
            showTitle: true,
         },
         render: message => (
            <Tooltip placement="right" title={message}>
               <span style={{ cursor: "default" }}>{message}</span>
            </Tooltip>
         ),
         width: '13%'
      },
      {
         title: 'Document Link',
         key: 'url_link',
         hidden: true,
         // dataIndex:'url_link',
         // width:'10%'
      },
      {
         title: 'Date Submitted',
         key: 'created_at',
         sorter: (a, b) => { return (a.created_at === null ? '' : a.created_at).localeCompare(b.created_at === null ? '' : b.created_at) },
         render: payload => {
            return <>
               {payload.is_late && <Tag color="red" style={{ marginLeft: "5px" }}>Late</Tag>}
               {payload.created_at}
            </>
         },
         width: '14%'
      },
      {
         title: 'Score',
         key: 'score',
         sorter: (a, b) => a.score - b.score,
         render: payload => {
            return <>
               {
                  payload.max_score !== null
                     ?
                     <span>{payload.score === 0 ? '' : payload.score + "/" + payload.max_score}</span>
                     :
                     <span>{payload.score === 0 ? '' : payload.score}</span>
               }
            </>
         },
         width: '6%'
      },
      {
         title: 'Remarks',
         key: 'remarks',
         dataIndex: 'remarks',
         ellipsis: {
            showTitle: true,
         },
         render: remarks => (
            <Tooltip placement="left" title={remarks}>
               <span style={{ cursor: "default" }}>{remarks}</span>
            </Tooltip>
         ),
         width: '15%'
      },
      {
         title: 'Evaluation Date',
         key: 'evaluation_date',
         dataIndex: 'evaluation_date',
         width: '11%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <>
               {payload.created_at
                  ?
                  <Space size="small">
                     {// payload.evaluation_id === null &&
                        <Tooltip placement="top" title='Evaluate'>
                           <AntDIcons.FormOutlined color='#033D89' style={{ cursor: 'pointer' }}
                              onClick={() => handleEvaluate(payload.id, payload.student_name, payload.document, payload.url_link, payload.evaluation_id, payload.score, payload.remarks, payload.max_score)}
                           />
                        </Tooltip>
                     }
                     {payload.evaluation_id !== null &&
                        <Tooltip placement="top" title='Remove Evaluation'>
                           <Popconfirm
                              title="Are you sure you want to remove the evaluation?"
                              onConfirm={() => handleRemoveEvaluation(payload.evaluation_id)}
                              okText="Yes"
                              cancelText="No"
                           >
                              <AntDIcons.DeleteOutlined color='#033D89' style={{ cursor: 'pointer' }} />
                           </Popconfirm>
                        </Tooltip>
                     }
                  </Space>
                  :
                  <></>
               }
            </>
         },
         width: '4%'
      },
   ].filter(item => !item.hidden);

   const getStudentSubmissions = (homework_id, level) => {
      setSubmissionListLoading(true);

      var url = `${process.env.REACT_APP_API_HOMEWORK}/studentlist?homework_id=${homework_id}&level=${level}&type=${props.type}`;
      axios.get(url).then((response) => {
         console.log(response);

         if (response.data) {
            const data = response.data;
            setSubmissionList(data);

            setSubmissionListLoading(false);
         }
      }, (error) => {
         setSubmissionListLoading(false);
         console.log(error.message);
      });
   }

   const handleEvaluate = (id, student_name, document, document_link, e_id, score, remarks, max_score) => {
      pdfFile = '';
      setDocumentTab("preview");
      setPlagiarismCheckerStatus({
         url: "",
         checking: false,
         checked: false,
         exists: false,
      });

      if (document !== null) {
         var docs = document.split(",");
         setUploadedDocs(docs);
         setSelectedDocumentIdx(0);
         setSubmittedDocument(docs[0]);
      } else {
         setUploadedDocs(null);
         setSelectedDocumentIdx(-1);
         setSubmittedDocument(null);
      }

      setDocumentLink(document_link);
      setStudentName(student_name);
      setScore(score || 0);
      setRemarks(remarks || "");
      setMaxScore(max_score);
      setSubmissionID(id);

      var o2o_mode = Utils.determineOnlineOffline(); //window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/gi) ? "offline" : "online";
      var evaluation_id = "homework_evaluation_" + o2o_mode + "_" + uuid();

      var initialEvaluationData = {
         Id: e_id === '' || e_id === null ? evaluation_id : e_id,
         Homework_submitted_id: id,
         Score: null,
         Remarks: null
      }

      // setScore(null);
      // setRemarks(null);

      setEvaluationData(initialEvaluationData);
      setCheckEvaluateModalVisible(true);
   }

   const handleSaveEvaluation = () => {
      if (score !== 0 || remarks !== '') {
         setEvaluating(true);

         var url = `${process.env.REACT_APP_API_HOMEWORK}/addevaluation`;

         var finalEvaluationData = {
            Id: evaluationData.Id,
            Homework_submitted_id: evaluationData.Homework_submitted_id,
            // Homework_id: evaluationData.Homework_id,
            // Student_id: evaluationData.Student_id,
            Score: score,
            Remarks: remarks,
         }

         axios.post(url, finalEvaluationData).then(response => {
            if (response.data) {
               setEvaluating(false);

               Modal.success({
                  title: 'Homework',
                  content: 'Homework evaluation added.',
                  centered: true,
                  onOk: () => { setCheckEvaluateModalVisible(false); },
               });

               getStudentSubmissions(props.homeworkID, props.levelID);
            }
         }, (error) => {
            setEvaluating(false);
            Modal.error({
               title: 'Homework',
               content: error.response.data,
               centered: true,
            });
         });
      }
   }

   const handleRemoveEvaluation = (id) => {
      setEvaluating(true);
      var url = `${process.env.REACT_APP_API_HOMEWORK}/removeevaluation?id=${id}`;

      axios.post(url).then(response => {
         if (response.data) {
            setEvaluating(false);

            Modal.success({
               title: 'Homework',
               content: 'Homework evaluation Removed.',
               centered: true,
            });

            getStudentSubmissions(props.homeworkID, props.levelID);
         }
      }, (error) => {
         setEvaluating(false);
         Modal.error({
            title: 'Homework',
            content: error.response.data,
            centered: true,
         });
      });
   }

   const handleCancelEvaluation = () => {
      setCheckEvaluateModalVisible(false);
   }

   const getFileExtension = (document) => {
      if (document === null || document === '')
         return '';

      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(document.toLowerCase());

      return ext && ext[1] ? ext[1] : '';
   }

   const shouldShowPlagiarismChecker = (document) => {
      return plagiarismSupportedFileTypes.includes(getFileExtension(document));
   }

   const getPlagiarismCheckerUrl = (document) => {
      const plagiarismCheckerBaseUrl = process.env.REACT_APP_PLAGIARISM_CHECKER_URL;

      if (plagiarismCheckerBaseUrl === undefined || plagiarismCheckerBaseUrl === null || plagiarismCheckerBaseUrl === '')
         return '';

      if (document === null || document === '')
         return '';

      const fileName = document.split(/[\\/]/).pop();
      const htmlFileName = fileName.replace(/\.[^/.]+$/, '') + '.html';
      const normalizedBaseUrl = plagiarismCheckerBaseUrl.endsWith('/') ? plagiarismCheckerBaseUrl : plagiarismCheckerBaseUrl + '/';

      return normalizedBaseUrl + encodeURIComponent(htmlFileName);
      // return normalizedBaseUrl + 'testfile1.html';
   }

   const getPlagiarismCheckerKey = (document) => {
      const plagiarismCheckerUrl = getPlagiarismCheckerUrl(document);

      if (plagiarismCheckerUrl === '')
         return '';

      try {
         return decodeURIComponent(new URL(plagiarismCheckerUrl).pathname.replace(/^\/+/, ''));
      } catch (error) {
         return '';
      }
   }

   const checkPlagiarismCheckerUrl = () => {
      const plagiarismCheckerUrl = getPlagiarismCheckerUrl(submittedDocument);
      const plagiarismCheckerKey = getPlagiarismCheckerKey(submittedDocument);

      if (plagiarismCheckerUrl === '' || plagiarismCheckerKey === '' || process.env.REACT_APP_API_S3_UPLOAD === undefined) {
         setPlagiarismCheckerStatus({
            url: plagiarismCheckerUrl,
            checking: false,
            checked: true,
            exists: false,
         });
         return;
      }

      setPlagiarismCheckerStatus({
         url: plagiarismCheckerUrl,
         checking: true,
         checked: false,
         exists: false,
      });

      axios.get(`${process.env.REACT_APP_API_S3_UPLOAD}/fileexists`, {
         params: {
            key: plagiarismCheckerKey,
         },
      }).then(response => {
         setPlagiarismCheckerStatus({
            url: plagiarismCheckerUrl,
            checking: false,
            checked: true,
            exists: response.data && response.data.exists === true,
         });
      }, error => {
         console.log(error.message);

         setPlagiarismCheckerStatus({
            url: plagiarismCheckerUrl,
            checking: false,
            checked: true,
            exists: false,
         });
      });
   }

   const renderPlagiarismChecker = () => {
      if (documentTab !== "plagiarism") return null;

      const plagiarismCheckerUrl = getPlagiarismCheckerUrl(submittedDocument);

      if (plagiarismCheckerUrl === undefined || plagiarismCheckerUrl === null || plagiarismCheckerUrl === '')
         return <div className='preview'>No plagiarism checker URL configured.</div>

      if (plagiarismCheckerStatus.url !== plagiarismCheckerUrl || plagiarismCheckerStatus.checking)
         return <div className='preview'>Your document is currently being scanned for potential plagiarism. Please wait a moment.</div>

      if (plagiarismCheckerStatus.checked && !plagiarismCheckerStatus.exists)
         return <div className='preview'>The plagiarism report is still being processed. Please check again in a few moments.</div>

      return <>
         <Iframe
            id="plagiarism-checker-iframe"
            title="plagiarism-checker-iframe"
            src={plagiarismCheckerUrl}
            frameBorder="0"
            height='100%'
            width='100%'
         />
      </>
   }

   const handleViewDoc = (doc, idx) => {
      setDocumentTab("preview");
      setPlagiarismCheckerStatus({
         url: "",
         checking: false,
         checked: false,
         exists: false,
      });
      setSelectedDocumentIdx(idx);
      setSubmittedDocument(doc);
   }

   const handleDocumentTabChange = (key) => {
      setDocumentTab(key);

      if (key === "plagiarism")
         checkPlagiarismCheckerUrl();
   }

   const handleReturn = () => {
      if (remarks !== '' && remarks !== null) {
         setEvaluating(true);

         var url = `${process.env.REACT_APP_API_HOMEWORK}/addevaluation`;

         var finalEvaluationData = {
            Id: evaluationData.Id,
            Homework_submitted_id: evaluationData.Homework_submitted_id,
            Score: score,
            Remarks: remarks,
            Returned: true
         }

         axios.post(url, finalEvaluationData).then(response => {
            if (response.data) {
               setEvaluating(false);

               Modal.success({
                  title: 'Homework',
                  content: 'Return submission successful.',
                  centered: true,
                  onOk: () => { setCheckEvaluateModalVisible(false); },
               });

               getStudentSubmissions(props.homeworkID, props.levelID);
            }
         }, (error) => {
            setEvaluating(false);
            Modal.error({
               title: 'Homework',
               content: error.response.data,
               centered: true,
            });
         });
      } else {
         Modal.info({
            title: 'Homework',
            content: 'Enter the reason for return in remarks section.',
            centered: true,
         });
      }
   }

   const { onDownload } = useDownloadExcel({
      currentTableRef: tableRef.current,
      filename: "homework_submissions",
      sheet: 'Homework Submissions'
   });

   const submittedCount = submissionList.filter(item => item.created_at).length;
   const evaluatedCount = submissionList.filter(item => item.evaluation_id !== null).length;
   const lateCount = submissionList.filter(item => item.is_late).length;
   const normalizedScore = Number(score || 0);
   const normalizedMaxScore = Number(maxScore || 0);
   const scorePercent = normalizedMaxScore > 0 ? Math.min(100, Math.round((normalizedScore / normalizedMaxScore) * 100)) : 0;

   return (
      <>
         {/* <Row gutter={12} style={{ minWidth: "400px", overflow: "auto" }}>
            <Col span={24}>
               <div className="dashboard-item-inner3">
                  <Table
                     rowKey={'uid'}
                     loading={submissionListLoading}
                     size='small'
                     columns={SubmissionListColumns}
                     dataSource={submissionList}
                     pagination={false}
                     scroll={{
                        y: 'calc(100svh - 20rem)',
                        x: '1000px',
                     }}
                     footer={() => 'Total Records: ' + submissionList.length}
                  />
               </div>
            </Col>
         </Row> */}
         <div className="homework-submissions-shell">
            <div className="homework-submissions-header">
               <div className="homework-submissions-heading">
                  <span className="homework-modal-section-icon"><AntDIcons.SolutionOutlined /></span>
                  <div>
                     <span className="homework-modal-kicker">Submissions</span>
                     <h3>{props.homeworkTitle}</h3>
                  </div>
               </div>
               <div className="homework-submissions-stats">
                  <span><AntDIcons.UserOutlined /> {submissionList.length} students</span>
                  <span><AntDIcons.CheckCircleOutlined /> {submittedCount} submitted</span>
                  <span><AntDIcons.FormOutlined /> {evaluatedCount} evaluated</span>
                  <span><AntDIcons.ClockCircleOutlined /> {lateCount} late</span>
               </div>
            </div>

            <div className="homework-submissions-table-shell">
               <Table
                  ref={tableRef}
                  className="homework-submissions-table"
                  rowKey={'uid'}
                  loading={submissionListLoading}
                  size='small'
                  columns={SubmissionListColumns}
                  dataSource={submissionList}
                  pagination={false}
                  scroll={{
                     y: 'calc(100svh - 26rem)',
                     x: '1000px',
                  }}
                  footer={() =>
                     <div className="homework-submissions-footer">
                        <span>Total Records: {submissionList.length}</span>
                        <Button type="primary" shape='round' size='small' icon={<AntDIcons.DownloadOutlined />} onClick={onDownload}>Export to Excel</Button>
                     </div>
                  }
               />
            </div>
         </div>

         <Modal
            title={"Evaluate Homework"}
            // className="homework-assignment-modal homework-evaluation-modal"
            centered
            destroyOnClose={true}
            open={checkEvaluateModalVisible}
            okText={"Save"}
            // onOk={() => handleSaveEvaluation()}
            onCancel={() => handleCancelEvaluation()}
            // width={window.innerWidth - 400}
            width='90%'
            cancelButtonProps={{ shape: "round" }}
            okButtonProps={{ shape: "round", style: { display: 'none' }}}
         >
            <Spin spinning={evaluating} tip="Adding evaluation, please wait...">
               <div className="homework-evaluation-summary">
                  <div className="homework-evaluation-summary-title">
                     <span className="homework-modal-section-icon"><AntDIcons.AuditOutlined /></span>
                     <div>
                        <span className="homework-modal-kicker">{workTypeLabel} Evaluation</span>
                        <h3>{props.homeworkTitle}</h3>
                     </div>
                  </div>
                  <div className="homework-evaluation-summary-meta">
                     <span><AntDIcons.UserOutlined /> {studentName || "Student"}</span>
                     <span><AntDIcons.StarOutlined /> {normalizedScore}/{normalizedMaxScore || maxScore || 0}</span>
                     <span><AntDIcons.PaperClipOutlined /> {uploadedDocs !== null ? uploadedDocs.length : 0} files</span>
                  </div>
               </div>
               <Row gutter={16} className="homework-evaluation-layout">
                  <Col xs={24} md={16} lg={16}>
                     <div className="homework-evaluation-preview-panel">
                        <div className="homework-modal-section-header">
                           <span className="homework-modal-section-icon"><AntDIcons.FileSearchOutlined /></span>
                           <div>
                              <span className="homework-modal-kicker">Review</span>
                              <h3>Submission Preview</h3>
                           </div>
                        </div>
                        <Tabs
                           className="homework-evaluation-tabs"
                           activeKey={props.plagiarismCheckerEnabled && shouldShowPlagiarismChecker(submittedDocument) ? documentTab : "preview"}
                           onChange={(key) => handleDocumentTabChange(key)}
                           onTabClick={(key) => {
                              if (key === "plagiarism" && documentTab === "plagiarism")
                                 checkPlagiarismCheckerUrl();
                           }}
                        >
                           <TabPane tab="Preview" key="preview">
                              <div className='modal-document-viewer homework-evaluation-document-viewer'>
                                 <DocumentViewer
                                    document={submittedDocument ? `${process.env.REACT_APP_S3_HOMEWORKS_STUDENTS_PATH}/${submittedDocument}` : null}
                                    documentname={submittedDocument}
                                    document_link={documentLink}
                                    dvheight="100%"
                                    emptydescription=""
                                    ismodal={true}
                                 />
                              </div>
                           </TabPane>
                           {
                              props.plagiarismCheckerEnabled && shouldShowPlagiarismChecker(submittedDocument) &&
                              <TabPane tab="Plagiarism Checker" key="plagiarism">
                                 <div className='modal-document-viewer homework-evaluation-document-viewer'>
                                    {renderPlagiarismChecker()}
                                 </div>
                              </TabPane>
                           }
                        </Tabs>
                     </div>
                  </Col>
                  <Col xs={24} md={8} lg={8}>
                     <SimpleBarReact className="homework-evaluation-side-scroll">
                        <div className="homework-evaluation-panel">
                           <div className="homework-modal-section-header">
                              <span className="homework-modal-section-icon"><AntDIcons.EditOutlined /></span>
                              <div>
                                 <span className="homework-modal-kicker">Evaluate</span>
                                 <h3><Text ellipsis>{studentName}</Text></h3>
                              </div>
                           </div>
                           <div className="homework-evaluation-score-card">
                              <div>
                                 <span>Current Score</span>
                                 <strong>{normalizedScore}/{normalizedMaxScore || maxScore || 0}</strong>
                              </div>
                              <Progress percent={scorePercent} size="small" showInfo={false} />
                           </div>
                           <Space direction='vertical' style={{ width: "100%" }}>
                              <label className="homework-modal-field-label">{`Score (Max: ${maxScore})`}</label>
                              <InputNumber
                                 min={0}
                                 max={maxScore}
                                 style={{ width: "100%" }}
                                 onChange={(val) => setScore(val)}
                                 value={score}
                                 placeholder="Enter score"
                              />
                              <label className="homework-modal-field-label">Remarks</label>
                              <TextArea
                                 allowClear
                                 rows={5}
                                 onChange={(event) => setRemarks(event.target.value)}
                                 placeholder="Write evaluation notes or return reason"
                                 value={remarks}
                              />
                              <Space className="homework-evaluation-actions" size={10}>
                                 <Popconfirm
                                    title="Are you sure you want to return submission?"
                                    onConfirm={() => handleReturn(submissionID)}
                                    okText="Yes"
                                    cancelText="No"
                                 >
                                    <Button shape='round' block>Return Submission</Button>
                                 </Popconfirm>
                                 <Button type='primary' shape='round' block onClick={() => handleSaveEvaluation()}>Save</Button>
                              </Space>
                           </Space>
                        </div>

                        <div className="homework-evaluation-panel">
                           <div className="homework-modal-section-header">
                              <span className="homework-modal-section-icon"><AntDIcons.PaperClipOutlined /></span>
                              <div>
                                 <span className="homework-modal-kicker">Files</span>
                                 <h3>Uploaded Documents</h3>
                              </div>
                              <span className="homework-modal-count">{uploadedDocs !== null ? uploadedDocs.length : 0}</span>
                           </div>
                           <SimpleBarReact className="homework-evaluation-documents">
                           {
                              uploadedDocs !== null &&
                              <>
                                 {
                                    <List
                                       size="small"
                                       dataSource={uploadedDocs}

                                       renderItem={(item, idx) =>
                                          <Tooltip placement="right" title={uploadedDocs[idx]}>
                                             <List.Item
                                                onClick={() => handleViewDoc(item, idx)}
                                                className={idx === selectedDocumentIdx ? 'document-file-selected' : 'document-file'}
                                             >
                                                {Utils.GetFileIcon(uploadedDocs[idx])} &nbsp;
                                                {uploadedDocs[idx]}
                                             </List.Item>
                                          </Tooltip>
                                       }
                                    />
                                 }
                              </>
                           }
                           </SimpleBarReact>
                        </div>
                     </SimpleBarReact>
                  </Col>
               </Row>
            </Spin>
         </Modal>
      </>
   );
}







